// src/components/navigation/BottomTabBar.jsx
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User, Dumbbell, Calendar, UserCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../utils/cn';

const patientTabs = [
  { path: '/profile', label: 'Profile', icon: User },
  { path: '/program', label: 'Program', icon: Dumbbell },
  { path: '/calendar', label: 'Calendar', icon: Calendar },
];

const providerTabs = [
  { path: '/profile', label: 'Profile', icon: User },
  { path: '/program', label: 'Program', icon: Dumbbell },
  { path: '/clients', label: 'Clients', icon: UserCircle },
];

export function BottomTabBar() {
  const location = useLocation();
  const { isProvider, isAdmin } = useAuth();
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone;
    setIsStandalone(standalone);
  }, []);

  const tabs = (isProvider || isAdmin) ? providerTabs : patientTabs;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 lg:hidden z-30"
      style={{
        paddingBottom: isStandalone ? 'env(safe-area-inset-bottom)' : undefined
      }}
    >
      <div className="flex justify-around items-center h-14">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname.startsWith(tab.path);

          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full py-2 relative",
                isActive ? "text-primary" : "text-gray-500"
              )}
            >
              <Icon className="h-6 w-6" />
              <span className="text-xs mt-1">{tab.label}</span>
              {isActive && (
                <div className="absolute top-0 left-4 right-4 h-0.5 bg-primary" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}